'use client';
import CategoryGrid, { GridType } from '@components/shared/CategoryGrid';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import GridItem from './_GridItem';
import axios from 'axios';
import CategoryBody from '../../components/shared/CategoryBody';

const LearnCategoryBody = ({
  body,
  learnCategory,
  _data,
  showBreadcrumb,
  breadcrumb,
  footer,
  learnTag,
}) => {
  const { locale } = useCurrentUrl();
  const { tags } = learnTag || {};
  const category = learnCategory?.categories;

  const loadData = async ({ page }, controller) => {
    return await axios.get('/api/learn/getLearnContent', {
      params: {
        category,
        page,
        tags,
        lang: locale,
      },
      signal: controller.signal,
    });
  };

  return (
    <CategoryBody
      breadcrumb={breadcrumb}
      showBreadcrumb={showBreadcrumb}
      footer={footer}
      body={body}
    >
      <CategoryGrid
        _data={_data}
        loadData={loadData}
        GridItemComponent={GridItem}
        type={GridType.Learn}
      />
    </CategoryBody>
  );
};

export default LearnCategoryBody;
